import { Keys, Scene } from "excalibur";
import { Player } from "../../player";
import { inventoryState, playerState } from "../../state/stateManager";
import { OpenHive } from "../../actors/openHive";
import { requeenHive, sendAlert, startStingTimer } from "../../utils";
import { goToScene } from "../../main";
import { Resources } from "../../Resources";

export default class RequeenMenu extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;

    this.activeItem = 0;
    this.selected = null;

    this.playerAnim = false;
  }
  onInitialize(engine) {
    this.engine = engine;
    this.inventory = inventoryState.getInventory();
    this.queensAvailable = this.inventory.queens;
  }
  onActivate(data) {
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.requeenMenu = document.getElementById("requeen-menu");
    if (this.queensAvailable > 4) {
      this.maximum = 4;
    } else {
      this.maximum = this.queensAvailable.length;
    }
    this.hiveStats = data.data;
    const hive = new OpenHive(335, 170, this.hiveStats);
    this.hive = hive;
    this.camera.zoom = 4;
    this.add(this.player);

    this.add(this.hive);
    console.log("requeenMenu: ", this.requeenMenu);
    this.requeenMenu.style.display = "block";
    this.showrequeenMenu();
    // this.requeenMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>

    //            ${this.showrequeenMenu(0)}
    //            `;
    if (this.hiveStats.alive) {
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "menu",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            this.stopTimer();
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  onDeactivate() {
    this.stingTimer && this.stingTimer.stop();
    this.selected = null;
    this.activeItem = 0;
    this.hive.kill();
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      console.log("requeen: pressed Down, maximum: ", this.maximum);
      Resources.Click.play();
      if (this.activeItem == this.maximum - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
      this.showrequeenMenu();
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      console.log("requeen: pressed up: maximum: ", this.maximum);
      Resources.Click.play();
      if (this.activeItem == 0) {
        this.activeItem = this.maximum - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }
      this.showrequeenMenu();
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (
        this.queensAvailable.length > 0 &&
        this.queensAvailable[this.activeItem] !== undefined
      ) {
        const req = requeenHive(
          this.hiveStats,
          this.queensAvailable[this.activeItem]
        );
        if (req) {
          this.inventory = inventoryState.getInventory();
          this.queensAvailable = this.inventory.queens;
          this.showrequeenMenu();
        }
      } else {
        Resources.Error.play();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      this.menuContainer.style.display = "none";
      this.requeenMenu.style.display = "none";
      goToScene("hiveMenu", this.hiveStats);
    }
  }
  showrequeenMenu() {
    console.log("requeen: inside requeen menu : ", this.activeItem);

    this.requeenMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
               
                <h3>Requeen Hive</h3>
    <h1>Queens</h1>
        <ul>
            ${
              this.queensAvailable.length > 0
                ? this.queensAvailable.map((queen, i) => {
                    console.log("requeen: inside map, ", i, " queen: ", queen);
                    if (i >= this.maximum) {
                      return;
                    } else {
                      if (i == this.activeItem) {
                        console.log(
                          "requeen: this should be the active item: ",
                          i,
                          queen
                        );
                        return `<li><span id="selector">></span>${queen.breed}</li>`;
                      } else {
                        return `<li>${queen.breed}</li>`;
                      }
                    }
                  })
                : "<h3>None Available</h3>"
            }
          </ul>
               `;
  }
}
